import React, { useEffect, useState } from 'react';
import './styles';
import UIDropdownSelect from '../../../../../components/UI/UIDropdownSelect';
import UIController from '../../../../../components/UI/UIController';
import Helmet from 'react-helmet';
import { TABS } from './config';
import { useDispatch } from 'react-redux';
import { updateFilter } from '../../../../../redux/store/filters/actions';
import moment from 'moment';
import AdminFinancesTechnicianPayment from './components/AdminFinancesTechnicianPayment';
import AdminFinancesUnpaid from './components/AdminFinancesUnpaid';
import { useLocation } from 'react-router-dom';
import AdminFinancesPartners from './components/AdminFinancesPartners';
import AdminFinancesPaid from './components/AdminFinancesPaid';
import * as strings from './strings';

export default function AdminFinances({}: AdminFinancesProps) {
	const [selectedPage, setSelectedPage] = useState<PLTab>(TABS.partners);

	const dispatch = useDispatch();
	const location = useLocation();

	const matchingPath = location.pathname;

	const updateFilterData = async () => {
		const currentDate = moment();
		const startOfMonth = moment().startOf('month');
		const startOfMonthPlusTwo = moment().startOf('month').add(2, 'weeks');
		if (currentDate.date() >= 15) {
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'startDate', value: startOfMonthPlusTwo.add(1, 'day') } }));
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'endDate', value: currentDate.endOf('month') } }));
		} else {
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'startDate', value: startOfMonth } }));
			dispatch(updateFilter({ route: matchingPath, filter: { name: 'endDate', value: startOfMonthPlusTwo } }));
		}
	};

	useEffect(() => {
		(async () => {
			await updateFilterData();
		})();
	}, []);

	const renderTabContent = (selectedPage) => {
		switch (selectedPage.value) {
			case TABS.partners.value:
				return <AdminFinancesPartners />;
			case TABS.unpaid.value:
				return <AdminFinancesUnpaid />;
			case TABS.paid.value:
				return <AdminFinancesPaid />;
			case TABS.technicianPay.value:
				return <AdminFinancesTechnicianPayment />;
			default:
				return null;
		}
	};

	return (
		<UIController className='paymentBody'>
			<Helmet>
				<title>{strings.pageTitle}</title>
				<meta property='og:title' content={strings.pageTitle} />
			</Helmet>
			<UIDropdownSelect
				containerClassName='paymentBody--tabs'
				selectedTab={selectedPage}
				tabs={[TABS.partners, TABS.unpaid, TABS.paid, TABS.technicianPay]}
				updateSelected={setSelectedPage}
			/>
			<div className='paymentContent'>{renderTabContent(selectedPage)}</div>
		</UIController>
	);
}
